import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { CustomButton } from "../../../../../components/customButton/CustomButton";
import { CustomDialog } from "../../../../../components/customDialog/CustomDialog";
import DataGridGenerico from "../../../../../components/dataGrid/DataGridGenerico";
import { useTabIndicationSaveIndicacionColumns } from "../../hooks/TabIndicacion/useTabIndicationSaveIndicacionColumns";
import { useTabIndicationAddIndicacionFields } from "../../hooks/TabIndicacion/useTabIndicationAddIndicacionFields";
import { useTabIndicationAddIndicacionOnSubmit } from "../../hooks/TabIndicacion/useTabIndicationAddIndicacionOnSubmit";
import { TabIndicacionFields } from "./TabIndicacionFields";
import { Toaster } from "react-hot-toast";

const INITIAL_VALUES = {
  fechaDesde: "",
  fechaHasta: "",
  insumo: { id: 0, label: "", descripcion: "", idUnidad: "", unidad: "" },
  cantidad: "",
  idUnidad: "",
  observacion: ""
};

export function TabIndicationAddIndicacionDialog({
  open,
  handleCloseDialog,
  idEvaluacion,
  refetch,
  refetchSolicitudes
}) {
  const [insumosAdded, setInsumosAdded] = useState([]);
  const [formValues, setFormValues] = useState(INITIAL_VALUES);

  const handleChange = (name, value) => {
    setFormValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const resetInsumoFields = () => {
    setFormValues({
      ...formValues,
      insumo: INITIAL_VALUES.insumo,
      cantidad: INITIAL_VALUES.cantidad,
      idUnidad: INITIAL_VALUES.idUnidad
    });
  };

  const areInsumoFieldsValid = () => {
    return formValues.insumo?.id && formValues.cantidad && formValues.idUnidad;
  };

  const addInsumoRow = () => {
    setInsumosAdded([
      ...insumosAdded,
      {
        idInsumoN: formValues.insumo.id,
        insumo: formValues.insumo.descripcion,
        cantidad: formValues.cantidad,
        idUnidad: formValues.insumo.idUnidad,
        unidad: formValues.insumo.unidad,
      },
    ]);

    resetInsumoFields();
  };

  const deleteInsumoRow = (idInsumoN) => {
    const filteredInsumos = insumosAdded.filter(
      (ins) => ins.idInsumoN !== idInsumoN
    );
    setInsumosAdded(filteredInsumos);
  };

  const columns = useTabIndicationSaveIndicacionColumns(deleteInsumoRow);

  const { firstRowfields, secondRowfields, thirdRowfields } =
    useTabIndicationAddIndicacionFields({
      idEvaluacion,
      insumosAdded,
      isAdding: true,
    });

  const { onSubmitSaveIndication, saveIndicationLoading } =
    useTabIndicationAddIndicacionOnSubmit({
      idEvaluacion,
      formValues,
      insumosAdded,
      handleCloseDialog,
      refetch,
      refetchSolicitudes
    });

  useEffect(() => {
    handleChange("idUnidad", formValues?.insumo?.idUnidad);
  }, [formValues.insumo]);

  return (
    <>
    <CustomDialog
      title="Solicitar indicación"
      open={open}
      fullWidth
      maxWidth="md"
      onCancel={handleCloseDialog}
      cancelText="Cancelar"
      acceptText="Guardar"
      onAccept={onSubmitSaveIndication}
      acceptLoading={saveIndicationLoading}
      acceptDisabled={insumosAdded.length === 0}
    >
      <Box display="flex" flexDirection="column" gap={3}>
        <TabIndicacionFields
          firstRowfields={firstRowfields}
          secondRowfields={secondRowfields}
          thirdRowfields={thirdRowfields}
          formValues={formValues}
          handleChange={handleChange}
        >
          <CustomButton
            label={"Agregar"}
            onClick={addInsumoRow}
            disabled={!areInsumoFieldsValid()}
          />
        </TabIndicacionFields>
        <DataGridGenerico
          columns={columns}
          rows={insumosAdded}
          toolbar={false}
          hideFooter
        />
      </Box>
    </CustomDialog>
    <Toaster />
    </>
  );
}
